import {
    SET_RULES_SUCCESS,
    SET_RULES_FAILURE,
    UPDATE_AIRLINE_SUCCESS,
    UPDATE_AIRLINE_FAILURE
} from './types';
import { getRules, getAirlinesList } from "./action"
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'react-admin';

function* showMessage() {
    yield put(getRules());
    yield put(showNotification('ra.messages.changesApplied', 'info'));
}

function* showErrors() {
    yield put(getRules());
    yield put(showNotification('ra.messages.failedOperation', 'warning'));
}

function* airlineUpdate() {
    yield put(getAirlinesList());
    yield put(showNotification('ra.messages.changesApplied', 'info'));
}

function* airlineUpdateFailure() {
    yield put(showNotification('ra.messages.failedOperation', 'warning'));
}

export default function* flightRequestSaga() {
    yield takeEvery(SET_RULES_FAILURE, showErrors);
    yield takeEvery(SET_RULES_SUCCESS, showMessage);
    yield takeEvery(UPDATE_AIRLINE_SUCCESS, airlineUpdate);
    yield takeEvery(UPDATE_AIRLINE_FAILURE, airlineUpdateFailure);
}